const BAD_IMAGE_HOST_RE = /(via\.placeholder\.com|cf\.shopee\.tw|img\.shopee\.tw)/i;

export const LOCAL_PLACEHOLDER = '/images/product-placeholder.svg';

export function buildGeneratedPlaceholder(seed = 'Product') {
  const safeSeed = String(seed || 'Product').replace(/[<>&"']/g, '').slice(0, 30);
  const svg = `
<svg xmlns="http://www.w3.org/2000/svg" width="800" height="800" viewBox="0 0 800 800" fill="none">
  <defs>
    <linearGradient id="bg" x1="0" y1="0" x2="1" y2="1">
      <stop offset="0%" stop-color="#F5F7FA"/>
      <stop offset="100%" stop-color="#EAF1F5"/>
    </linearGradient>
  </defs>
  <rect width="800" height="800" rx="40" fill="url(#bg)"/>
  <rect x="120" y="170" width="560" height="380" rx="28" fill="#FFFFFF" stroke="#C9D6E2"/>
  <circle cx="250" cy="300" r="52" fill="#D6E4EE"/>
  <path d="M170 490L300 360L390 450L470 390L620 550H170V490Z" fill="#D6E4EE"/>
  <text x="400" y="630" text-anchor="middle" font-family="Arial, sans-serif" font-size="36" fill="#486581">${safeSeed}</text>
</svg>`;
  return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`;
}

export function normalizeImageUrl(url, fallbackText = 'Product') {
  const raw = String(url || '').trim();
  if (!raw) return LOCAL_PLACEHOLDER;
  if (BAD_IMAGE_HOST_RE.test(raw)) return buildGeneratedPlaceholder(fallbackText);
  return raw.replace(/([^:]\/)\/+/g, '$1');
}

export function onImageErrorSetFallback(event, fallbackText = 'Product') {
  const el = event.currentTarget || event.target;
  if (!el) return;
  if (el.dataset.fallbackApplied === '1') return;
  el.dataset.fallbackApplied = '1';
  el.src = buildGeneratedPlaceholder(fallbackText);
}
